import React from 'react';
import { LangSwitcher, ProfileMenuDecorated, HelpMenu } from 'components/header/control-bar/fragments/index';

export const ControlBar = () => {
  return (
    <div className="ct-control-bar" data-e2e="user-control-bar">
      <ProfileMenuDecorated />
      <LangSwitcher />
      <HelpMenu />
    </div>
  );
};
